export default {
    breakpoints: ['450px', '768px', '1200px'],
    fontSizes: [
        12, 14, 16, 20, 24, 32, 48, 64
    ],
    space: [
        0, 4, 8, 16, 32, 64, 128, 256, 512, 768, 2014
    ],
    fonts: {
        body: 'Rozha One, serif',
        heading: 'Rozha One, serif',
        monospace: 'Menlo, monospace',
    },
    colors: {
        black: "#555555e3",
        otherBlack:"#232323",
        lightBluePrimary: "#aad1ff",
        blueDark: "#6fb0ff",
        pinkPrimary: "#fad2d2",
        pinkDark: "#ffc9c9",
        purplePrimary: "#c2bce7",
        purpleDark: "#b4abea",
        creamPrimary: "#d5c1ae",
        creamDark: "#d5bda6",
        greenPrimary: "#a8cd94",
        greenDark: "#9cc088",
        secondary :"#afbbd6",
        darkSecondary: "#9298a9",
        darkMatte: "#a3a8a1",
        moreDark: "#979793",
        gray: "#252525d4",
    },
    lineHeights: {
        body: 1.5,
        heading: 1.25,
    },
    shadows: {
        small: '0 0 4px rgba(0, 0, 0, .125)',
        large: '0 0 24px rgba(0, 0, 0, .125)'
    },
}